import React, { useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import CdsCheckoutOrderItem from "./CdsCheckoutOrderItem"
import classes from "./CdsCheckoutContents.module.scss"

const CdsCheckoutContents = (props) => {
  const { orderItems } = props

  const [t, i18n] = useTranslation()

  const ref = useRef(null)

  const scrollDownWhenOrderItemsChanged = () => {
    ref.current &&
      ref.current.scrollTo({
        top: 1000000000,
        left: 0,
        behavior: "smooth"
      })
  }

  useEffect(() => {
    scrollDownWhenOrderItemsChanged()
  }, [orderItems])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      ref={ref}
      className={classes["container"]}
    >
      <table
        className={clsx(
          classes["table"],
          isLtr && classes["table-ltr"]
        )}
      >
        <thead>
          <tr>
            <th className={classes["image"]} />

            <th className={classes["name"]}>
              {t("نام_آیتم")}
            </th>

            <th className={classes["quantity"]}>
              {t("تعداد")}
            </th>

            <th
              className={clsx(
                classes["subtotal"],
                isLtr && classes["subtotal-ltr"]
              )}
            >
              {t("مجموع")}
            </th>
          </tr>
        </thead>

        <tbody>
          {orderItems.map(orderItem => (
            <CdsCheckoutOrderItem
              key={orderItem.orderItemId}
              orderItem={orderItem}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default CdsCheckoutContents